import { scopedTranslation } from '@frontend/utils/I18n'

import { PublishRosterDocument } from '@frontend/graphql/mutations/publishRoster.generated'

import type { Roster } from '@frontend/graphql/types.generated'

import { useRosterActionMutation } from '../roster_board/useRosterActionMutation'

type PublishRosterValues = {
  rosterId: Roster['id']
  shiftIds?: string[]
  onSuccess: () => void
}

const t = scopedTranslation('components.publish_roster')

const usePublishRosterMutation = () => {
  const { run } = useRosterActionMutation({
    document: PublishRosterDocument,
    succeeded: (response) => Boolean(response?.publishRoster?.success),
    errorCode: 'PUBLISH_ROSTER_ERROR',
    failureMessage: t('errors.unable_to_publish_roster_generic_error'),
    errorsPath: 'publishRoster',
    extractErrors: (response) => response?.publishRoster?.errors,
  })

  return ({ rosterId, shiftIds, onSuccess }: PublishRosterValues) =>
    run({ id: rosterId, ...(shiftIds ? { shiftIds } : {}), onSuccess })
}

export default usePublishRosterMutation
